import { VISUAL_ELEMENT_SIZE_MAP } from '../shared/constants.js';

const validChildren = ['Avatar', 'CryptoIcon', 'FiatIcon', 'FileIcon', 'IconBadge', 'MerchantIcon'];
const SVG_MAP = {
  lg: {
    base: {
      size: VISUAL_ELEMENT_SIZE_MAP.lg
    },
    pair: {
      size: VISUAL_ELEMENT_SIZE_MAP.sm
    }
  },
  xl: {
    base: {
      size: VISUAL_ELEMENT_SIZE_MAP.xl
    },
    pair: {
      size: VISUAL_ELEMENT_SIZE_MAP.sm
    }
  }
};

export { SVG_MAP, validChildren };
